import {
  HiqLrpTypeCodeNames,
  RmaCommodityTypeNames,
  RmaLrpCommodityCodes,
  RmaLrpCommodityNames,
  RmaLrpTypeCodes,
} from '@harvestiq/constants';
import { z, zDecimalRequired, zIsoDate } from '@harvestiq/zod';
import { dbLrpRateDailySchema } from './db-lrp-rate-daily';

export const lrpQuoteSchema = dbLrpRateDailySchema.extend({
  subsidy: zDecimalRequired(),
  producerPremium: zDecimalRequired(),
  commodityCode: z.nativeEnum(RmaLrpCommodityCodes),
  commodityName: z.nativeEnum(RmaLrpCommodityNames),
  commodityTypeName: z.nativeEnum(RmaCommodityTypeNames),
  typeCode: z.nativeEnum(RmaLrpTypeCodes),
  typeDisplay: z.nativeEnum(HiqLrpTypeCodeNames),
  optionsName: z.string(),
  priceAdjustmentFactor: zDecimalRequired(),
  barchartFuturesSymbol: z.string().nullable(),
  endDateMonth: z.string(),
  endDateMonthName: z.string(),
  // below are obtained from barchart futures data
  monthDiff: z.number(),
  cmeEquivalentDateMonth: z.string(),
  comparisonPrice: z.number(),
  last: zDecimalRequired(),
  previousClose: zDecimalRequired(),
  settlement: z.number().optional(),
  previousSettlement: z.number().optional(),
  savingsVsCmeTrade: zDecimalRequired(),
  savingsVsCmeTradeDollar: zDecimalRequired(),
  finalSettlement: z.number(),
  publicationDate: z.string(),
  commodityType: z.string(), // It differs from commodityTypeName as it has weight information
  // below are duplicates but we need to keep as the api is exposed - backwards compatibility
  commodity: z.string(),
  marketingDate: zIsoDate(),
  coverageLevel: zDecimalRequired(),
  expectedEndingValue: zDecimalRequired(),
  marketingMonthNumber: z.string().optional(),
});

export type LrpQuote = z.infer<typeof lrpQuoteSchema>;
